module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.674f50d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/fa/fontawesome-webfont.eot
// module id = 692
// module chunks = 1